const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const categoryService = {
  // Get all categories
  async getCategories(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const response = await fetch(`${API_BASE_URL}/categories?${queryString}`);
    if (!response.ok) throw new Error('Failed to fetch categories');
    return response.json();
  },

  // Get category tree structure
  async getCategoryTree() {
    const response = await fetch(`${API_BASE_URL}/categories/tree`);
    if (!response.ok) throw new Error('Failed to fetch category tree');
    return response.json();
  },

  // Get single category by ID
  async getCategoryById(id) {
    const response = await fetch(`${API_BASE_URL}/categories/${id}`);
    if (!response.ok) throw new Error('Failed to fetch category');
    return response.json();
  },

  // Get category by slug with products
  async getCategoryBySlug(slug, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const response = await fetch(`${API_BASE_URL}/categories/slug/${slug}?${queryString}`);
    if (!response.ok) throw new Error('Failed to fetch category');
    return response.json();
  },

  // Create category (admin)
  async createCategory(categoryData, image, banner) {
    const formData = new FormData();
    formData.append('category', JSON.stringify(categoryData));
    
    if (image) formData.append('image', image);
    if (banner) formData.append('banner', banner);

    const response = await fetch(`${API_BASE_URL}/categories`, {
      method: 'POST',
      body: formData,
    });
    
    if (!response.ok) throw new Error('Failed to create category');
    return response.json();
  },

  // Update category (admin)
  async updateCategory(id, categoryData, image, banner) {
    const formData = new FormData();
    formData.append('category', JSON.stringify(categoryData));
    
    if (image) formData.append('image', image);
    if (banner) formData.append('banner', banner);

    const response = await fetch(`${API_BASE_URL}/categories/${id}`, {
      method: 'PUT',
      body: formData,
    });
    
    if (!response.ok) throw new Error('Failed to update category');
    return response.json();
  },

  // Delete category (admin)
  async deleteCategory(id) {
    const response = await fetch(`${API_BASE_URL}/categories/${id}`, {
      method: 'DELETE',
    });
    
    if (!response.ok) throw new Error('Failed to delete category');
    return response.json();
  },

  // Update category order (admin)
  async updateCategoryOrder(id, order) {
    const response = await fetch(`${API_BASE_URL}/categories/${id}/order`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ order }),
    });
    
    if (!response.ok) throw new Error('Failed to update category order');
    return response.json();
  }
};
